import type { Reviewer } from "./ReviewersEditList";

/**
 * Sentinel reviewer representing the open Encamp-staff peer-review queue ("any
 * staff can review"), surfaced as the first option in the stepper's staff
 * reviewer picker. It is not a real user — callers map it to the
 * `peerReviewRequired` flag rather than persisting a SubmissionReviewer.
 *
 * Kept in its own module (not `ReviewersEditList`) so that file only exports
 * components (react-refresh/only-export-components).
 */
export const ANY_ENCAMP_STAFF_REVIEWER_ID = "any-encamp-staff";

export const ANY_ENCAMP_STAFF_REVIEWER: Reviewer = {
  id: ANY_ENCAMP_STAFF_REVIEWER_ID,
  name: "Any Encamp Staff member",
  email: "",
  order: 0,
  isStaff: true,
};
